import React from 'react'
import { ImagePanorama, Viewer } from 'panolens'
import { TextureLoader, ImageUtils } from 'three'
import { StyledWrapper, StyledCarouselControl, StypedPano } from './styled'
import Arrow from './../../../../common/images/arrow.svg'


const Photos360 = (props) => {
    
    const [index, setIndex] = React.useState(0)
    let viewer
    
    const textureLoader = new TextureLoader();
    textureLoader.crossOrigin = '*'
    let panorama = new ImagePanorama(props.photos_360[index].image.url)

    React.useEffect(() => {
        const panoImagesContainer = document.querySelector(`.pano-image-${props.index}`)
        viewer = new Viewer({
            container: panoImagesContainer,
            autoRotate: true,
            autoRotateSpeed: 0.2,
            controlButtons: ['fullscreen']
        })
        viewer.add(panorama)
    }, [])

    const resetViewer = () => {
        if(!viewer) {
            document.querySelector(`.pano-image-${props.index}`).innerHTML=''
                viewer = new Viewer({
                    container: document.querySelector(`.pano-image-${props.index}`),
                    autoRotate: true,
                    autoRotateSpeed: 0.2,
                    controlButtons: ['fullscreen']
                })  
            }
    }
    
    const handleSlideChange = (direction) => {
        

        
        
        if(direction === 'next') {
            if(index < props.photos_360.length -1) {
                resetViewer()
                viewer.remove(panorama)
                panorama = new ImagePanorama( props.photos_360[index + 1].image.url );
                viewer.add(panorama)
                viewer.setPanorama(panorama)
                setIndex(index + 1)
            }
             
        }

        if(direction === 'prev') {
            if(index > 0) {
                resetViewer()
                viewer.remove(panorama)
                panorama = new ImagePanorama( props.photos_360[index - 1].image.url );
                viewer.add(panorama)
                viewer.setPanorama(panorama)
                setIndex(index - 1)
            }
        }


    }
    
    return (
            <StyledWrapper>
                <StyledCarouselControl side='left' onClick={() => handleSlideChange('prev')}>
                <img src={Arrow} alt=''/>
            </StyledCarouselControl>

            <StyledCarouselControl side='right' onClick={() => handleSlideChange('next')}>
                <img src={Arrow} alt=''/>
            </StyledCarouselControl>
                <StypedPano className={`pano-image-${props.index}`}>
                </StypedPano>
            </StyledWrapper>
    )
}

export default Photos360